import React from 'react';
import { VictoryPie, VictoryLabel } from 'victory';

const colors = ['#2693e6', '#e66926', '#b026e6', '#e6c926', '#eeeeee', '#86d3ff'];

export const PieChart = ({ data, labelText }) => (
    <div>
        <h4 css={{ textAlign: 'center', marginTop: 16, marginBottom: 0 }}>{labelText}</h4>
        <VictoryPie
            animate={{ duration: 800 }}
            colorScale={colors}
            data={data}
            innerRadius={120}
            labelRadius={240}
            width={800}
            height={800}
            style={{ labels: { fontSize: 28, fill: 'black' } }}
        />
    </div>
);
